import { nextTick } from 'vue';

interface IShowPickerOptions {
  beforeShow?: () => void;
  hideOther?: () => void;
  show: () => Promise<void> | void;
}

type TShowAnchoredPickerOptions = IShowPickerOptions &
  ({ anchor?: HTMLElement; setAnchor: (anchor: HTMLElement) => void } | { anchor?: never; setAnchor?: never });

export const showAnchoredPicker = async (options: TShowAnchoredPickerOptions): Promise<void> => {
  if (options.anchor) options.setAnchor(options.anchor);
  options.hideOther?.();
  options.beforeShow?.();
  await nextTick();
  await options.show();
};
